<router>
{
    name: 'Dorset Controls Central Server',
}
</router>
<template lang="pug">
v-container
    v-row
        v-col
            serverSettings

</template>
<script>

import serverSettings from '@/components/dccs/serverSettings.vue';
export default {
    meta: {
        role: 'admin'
    },
    components: {
        serverSettings
    },
    data () {
        return {
        };
    },
    methods: {

    },
    computed: {

    },
    mounted () {
    }
};
</script>

<style scoped>
</style>
